<template>
  <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
    <template v-if="loading">
      <div v-for="i in 5" :key="i" class="bg-white rounded-xl border border-gray-200 p-5 animate-pulse">
        <div class="h-4 bg-gray-200 rounded w-24 mb-4"></div>
        <div class="h-8 bg-gray-200 rounded w-20 mb-3"></div>
      </div>
    </template>
    <div v-else-if="error" class="col-span-full bg-red-50 border border-red-200 rounded-xl p-4 flex items-center justify-between">
      <span class="text-sm text-red-600">{{ error }}</span>
      <button @click="refresh" class="text-sm text-red-700 font-medium hover:underline">Reessayer</button>
    </div>
    <template v-else-if="data">
      <div
        v-for="kpi in kpis"
        :key="kpi.key"
        class="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-lg transition-all"
      >
        <div class="flex items-center gap-2 mb-3">
          <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" :class="kpi.bgClass">
            <i :class="'fa-solid fa-' + kpi.icon" style="font-size: 18px; color: white;"></i>
          </div>
          <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">{{ kpi.label }}</span>
        </div>
        <div class="text-xl font-extrabold tracking-tight" :class="kpi.textClass || 'text-primary'">
          {{ kpi.formatted }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { formatCurrency, formatInteger } from './helpers'

const { data, loading, error, refresh } = useDashboard('/dashboard/kpi/products')

const kpis = computed(() => {
  if (!data.value) return []
  const d = data.value
  return [
    { key: 'total_products', label: 'Total produits', formatted: formatInteger(d.total_products), icon: 'box', bgClass: 'bg-primary', textClass: 'text-primary' },
    { key: 'active_products', label: 'Produits actifs', formatted: formatInteger(d.active_products), icon: 'check-circle', bgClass: 'bg-green-500', textClass: 'text-green-700' },
    { key: 'stock_value', label: 'Valeur du stock', formatted: formatCurrency(d.stock_value), icon: 'boxes', bgClass: 'bg-blue-500', textClass: 'text-blue-700' },
    { key: 'low_stock_count', label: 'Stock faible', formatted: formatInteger(d.low_stock_count), icon: 'exclamation-triangle', bgClass: 'bg-orange-500', textClass: 'text-orange-700' },
    { key: 'out_of_stock_count', label: 'Rupture de stock', formatted: formatInteger(d.out_of_stock_count), icon: 'times-circle', bgClass: 'bg-red-500', textClass: 'text-red-700' }
  ]
})
</script>
